import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ReviewArticle from "../pages/article/review/page";
import ShippingArticle from "../pages/article/shipping/page";
import WarehouseArticle from "../pages/article/warehouse/page";
import CouponArticle from "../pages/article/coupon/page";
import LegitArticle from "../pages/article/legit/page";
import VsArticle from "../pages/article/vs/page";
import HowToArticle from "../pages/article/howto/page";
import ShoesArticle from "../pages/article/shoes/page";
import HoodiesArticle from "../pages/article/hoodies/page";
import TipsArticle from "../pages/article/tips/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/basetao-spreadsheet-guide",
    element: <ArticlePage />,
  },
  {
    path: "/basetao-spreadsheet-review",
    element: <ReviewArticle />,
  },
  {
    path: "/basetao-shipping-cost",
    element: <ShippingArticle />,
  },
  {
    path: "/basetao-warehouse-guide",
    element: <WarehouseArticle />,
  },
  {
    path: "/basetao-coupon-code",
    element: <CouponArticle />,
  },
  {
    path: "/is-basetao-legit",
    element: <LegitArticle />,
  },
  {
    path: "/basetao-vs-superbuy",
    element: <VsArticle />,
  },
  {
    path: "/basetao-how-to-use",
    element: <HowToArticle />,
  },
  {
    path: "/basetao-spreadsheet-shoes",
    element: <ShoesArticle />,
  },
  {
    path: "/basetao-spreadsheet-hoodies",
    element: <HoodiesArticle />,
  },
  {
    path: "/basetao-shopping-tips",
    element: <TipsArticle />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;